import { call, put, takeEvery } from "redux-saga/effects";
import { RetailMatchGeographyOption } from "../../../Enums/RetailMatchGeographyOption";
import { IRetailMatchJob } from "../../../Models/IRetailMatch";
import { IRetailMatchGeography } from "../../../Models/IRetailMatchGeography";
import { ISubmitRetailMatchJobRequest } from "../../../Models/Requests/ISubmitRetailMatchJobRequest";
import * as actions from "../Actions/RetailMatchActions";
import * as api from "../API/RetailMatchApi";
import * as types from "../Types/RetailMatchActionTypes";
import { IReportProgress } from "../Models/IReportProgress";
import { getPendingReportProgress } from "../Components/SubmittedReport/SubmittedReportLogic";
import { setReportProgress } from "../Actions/ReportActions";

export function* watchRetailMatchSagas() {
    yield takeEvery(
        types.GET_RETAIL_MATCH_GEOGRAPHIES_INITIATE,
        getRetailMatchGeographiesSaga
    );
    yield takeEvery(
        types.SUBMIT_MATCH_REPORT_INITIATE,
        submitMatchReportSaga
    );
    yield takeEvery(
        types.SITE_IS_IN_DMA_INITIATE,
        siteIsInDMASaga
    );
}

export function* getRetailMatchGeographiesSaga(action: types.RetailMatchActionType) {
    try {
        yield put(actions.setLoadingRetailMatchGeographies(true));
        const geos: IRetailMatchGeography[] = yield call(() =>
            api.getRetailMatchGeographies(action.data as RetailMatchGeographyOption)
        );
        yield put(actions.getRetailMatchGeographiesSuccess(geos));
    } catch (e) {
        yield put(actions.getRetailMatchGeographiesFailure(e));
    } finally {
        yield put(actions.setLoadingRetailMatchGeographies(false));
    }
}

export function* submitMatchReportSaga(action: types.RetailMatchActionType) {
    try {
        yield put(actions.setMostRecentlySubmittedRetailMatchReport(null));
        const request = action.data as ISubmitRetailMatchJobRequest;
        yield put(actions.startLastReportRunning(request.title));
        yield put(actions.setLoadingMatchReport(true));
        const job: IRetailMatchJob = yield call(() =>
            api.submitMatchReport(request)
        );
        yield put(actions.submitMatchReportSuccess(job));
        const startProgress: IReportProgress = getPendingReportProgress();
        yield put(setReportProgress(startProgress));
    } catch (e) {
        yield put(actions.submitMatchReportFailure(e));
    } finally {
        yield put(actions.setLoadingMatchReport(false));
    }
}

export function* siteIsInDMASaga(action: types.SiteIsInDMAInitiateAction) {
    try {
        yield put(actions.setCheckingtSiteIsInDMA(true));

        const siteIsInDMA: boolean = yield call(() =>
            api.siteIsInDMA(action.data.latitude, action.data.longitude)
        );
        yield put(actions.siteIsInDMASuccess(siteIsInDMA));
    } catch (e) {
        yield put(actions.siteIsInDMAFailure(e));
    } finally {
        yield put(actions.setCheckingtSiteIsInDMA(false));
    }
}
